export const splitHtml = (html: string): [string, string] => {
  const matches = Array.from(html.matchAll(/<\/p>/gi));

  if (matches.length === 0) return [html, ''];

  const middleIndex = Math.floor(matches.length / 2);

  // Берём индекс окончания middleIndex-го </p>
  const cutMatch = matches[middleIndex - 1];

  if (!cutMatch || cutMatch.index === undefined) {
    return [html, ''];
  }

  const cutPos = cutMatch.index + 4; // +4 длина '</p>'
  const first = html.slice(0, cutPos);
  const second = html.slice(cutPos);

  return [first, second];
};
